

















import { calcRelocation } from '@/util/color-util';
import Vue from 'vue';

const COLOR_BAR_CELL_NUM = 20;  // 凡例カラーバーの分割数

/**
 * ヒートマップ用カラーバー。
 */
export default Vue.extend({
  name: 'HeatmapColorBar',
  props: {
    title:{
      type: String,
      default: '',
    },
    minValue: Number, // ヒートマップデータの最小値
    maxValue: Number, // ヒートマップデータの最大値
    clacValueToColorFunc: Function, // 数値から色に変換する関数
  },
  data() {
    return {
    };
  },
  computed: {
    COLOR_BAR_CELL_NUM():number{
      return COLOR_BAR_CELL_NUM;
    },
    MID_VALUE(): number { // 最小値、最大値の中間値
      return Math.floor((this.minValue + this.maxValue) * 0.5);
    }
  },
  methods: {
    getColorBarCellStyle(index: number){
      const value = calcRelocation( index, 0, COLOR_BAR_CELL_NUM, this.minValue, this.maxValue);
      const color = this.clacValueToColorFunc(value, this.minValue, this.maxValue);
      return {
        background: color
      };
    }
  },
});
